import { Platform } from '@ionic/angular';
import { Injectable, Inject, Component } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Storage } from '@ionic/storage';
import { ApiService } from '../../services/api/api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


export interface DialogData {
  animal: string;
  name: string;
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  category: any;
  authenticationState = new BehaviorSubject(false);
  const:any;

  constructor(public dialog: MatDialog, private storage: Storage, private plt: Platform, private apiService: ApiService, private spinner: NgxSpinnerService) {
    this.plt.ready().then(() => {
      this.checkToken();
    });
   }


  public checkToken() {
    this.storage.get('auth').then(res => {
      if (res) {
        this.authenticationState.next(true);
      }
    });
  }


  login(data) {
    this.spinner.show();
    this.apiService.login(data).subscribe((response) => {
      console.log(response);
      if (response.status === true) {
        localStorage.setItem('user', response.data.customer[0].customer_id);
        localStorage.setItem('token', response.data.token.access_token);
        return this.storage.set('auth', true).then(() => {
          this.spinner.hide();
          this.authenticationState.next(true);
      });
      }
      //fz
      else{
        this.openDialog()
        console.log('error popup login');

      }
      //end
  });

  }

  openDialog(): void {
    const dialogRef = this.dialog.open(DialogErrorLoginPage, {
      width: '280px',
      data: {name: 'name', animal: 'hello'}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

  register(data) {
    this.apiService.register(data).subscribe((response) => {
      console.log(response);
      if (response.status === true) {
        this.authenticationState.next(false);
    }
  });

  }

  logout() {
    localStorage.clear();
    return this.storage.remove('auth').then(() => {
      this.authenticationState.next(false);
    });
  }

  isAuthenticated() {
    return this.authenticationState.value;
  }


}


@Component({
  selector: 'mydialog',
  templateUrl: 'dialog.html',
})
export class DialogErrorLoginPage {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

}
